import styled, { css } from 'styled-components';

import { Text, Button } from '@gympass/yoga';
import { media } from '@gympass/yoga-helpers';

import { Button as CpButton } from 'components/Button';
import Input from 'components/Input';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  margin: ${({ theme }) => theme.yoga.spacing.zero} auto;
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  padding: ${({ theme }) => theme.yoga.spacing.xlarge}px
    ${({ theme }) => theme.yoga.spacing.xlarge}px
    ${({ theme }) => theme.yoga.spacing.xsmall}px;
`;

export const Title = styled(Text.H4)`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;

export const Form = styled.form`
  > :not(:first-child) {
    margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
  }
`;

const inputStyle = css`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  border-width: 1px;
  height: 50px;

  ${media.md`
    height: initial;
  `};
`;

export const LoginInput = styled(Input)`
  ${inputStyle};
`;

export const LoginEmailInput = styled(Input)`
  ${inputStyle};
`;

export const LoginPasswordInput = styled(Input)`
  ${inputStyle};
`;

export const TextButton = styled(Button.Text)`
  display: inline-block;
  padding-left: ${({ theme }) => theme.yoga.spacing.zero}px;
`;

export const ActionButtonContainer = styled.div`
  bottom: 0;
  left: 0;
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  padding-bottom: ${({ theme }) => theme.yoga.spacing.xxlarge}px;

  ${media.md`
    position: relative;
    padding-bottom: 0;
  `};
`;

export const ActionButton = styled(props => <CpButton {...props} />)`
  flex: auto;
  padding-left: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  padding-right: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  margin: ${({ theme }) => theme.yoga.spacing.xlarge}px
    ${({ theme }) => theme.yoga.spacing.medium}px
    ${({ theme }) => theme.yoga.spacing.zero};

  ${media.md`
      flex: initial;
  `};
`;
